export const ACCOUNT_BUTTON_LABEL = 'Next';

export const ACCOUNT_FORM_TITLE = 'Create your account.';
export const EMAIL_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'aol.com',
  'yahoo.com',
];

export const BUSINESS_INFO_MODAL_ROUTE = 'business-info';
export const PROFILE_MODAL_ROUTE = 'profile';
export const VERIFY_ACCOUNT_MODAL_ROUTE = 'verify-account';
